import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';

// reactstrap components
import { Button, Card, CardBody, CardHeader, FormGroup, Form, Input, Row, Col, Spinner } from "reactstrap";
import Select from 'react-select';

// helpers
import { showMessage } from "../../helpers/message.js";
import { formateDateApi } from '../../helpers/formats';
import { InputCEP } from "../../helpers/mask.js";
import { isValidCNPJ, isValidCPF } from '../../helpers/valid';

// api
import guiadestinacao_api from "../../api/guiadestinacao_api.js";
import transportador_api from "../../api/transportador_api";
import destino_api from "../../api/destino_api";
import cep_api from "../../api/cep_api.js";

//Context
import { useAuth } from "../../context/auth.js";

export default function GuiaDestinacaoForm({ item, handleReturn }) {
  const { session, setLoading } = useAuth();

  const { register, handleSubmit, errors, setError, setValue, clearErrors, getValues } = useForm({ mode: "onBlur" });

  const [form_disabled, set_form_disabled] = useState(false);

  const [list_table, set_list_table] = useState([]);

  const Voltar = () => {
    handleReturn();
  }

  useEffect(() => {
    loadForm();
  }, []);

  const loadForm = () => {
    setLoading(true);
    guiadestinacao_api.getItemFromFicha(session.localId, item == null ? 0 : item.guiaDestinacaoId).then(result => {
      setLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        setValue("documento", result.data.documento);
        setValue("identificacao", result.data.identificacao);
        setValue("cep", result.data.cep);
        set_cep(result.data.cep);
        setValue("logradouro", result.data.logradouro);
        setValue("numero", result.data.numero);
        setValue("complemento", result.data.complemento);
        setValue("bairro", result.data.bairro);
        setValue("cidade", result.data.cidade);
        setValue("uf", result.data.uf);

        setValue("numeroEquipamento", result.data?.numeroEquipamento);

        set_list_table(result.data.guiaDestinacaoTipoResiduo);

        set_transportadorId(result.data.transportadorId);

        if (result.data.placa != "")
          handleVeiculo(result.data.placa);
        if (result.data.destinoId != null)
          handleDestino(result.data.destinoId);

        set_form_disabled(item != null);
      }
    });
  }

  const [transportadorId, set_transportadorId] = useState(null);
  const handleCNPJBlur = (event) => {
    setLoading(true);
    transportador_api.getByCNPJ(event.target.value.replace(/[^\d]+/g, '')).then(result => {
      setLoading(false);
      if (result.status == 204) {
        set_transportadorId(null);
        setValue("identificacao", "");
      }
      else if (result.status !== 200) {
        showMessage("Aviso", "Não foi possível consultar o CNPJ", 'error', function () {
          set_transportadorId(null);
          setValue("identificacao", "");
          setValue("documento", "");
        });
      }
      else {
        set_transportadorId(result.data.transportadorId);
        setValue("identificacao", result.data.fantasia);
      }
    });
  }
  useEffect(() => {
    if (transportadorId != null) {
      loadVeiculos();
      loadDestino();
    }
  }, [transportadorId]);

  // VEICULO
  const [veiculo, set_veiculo] = useState(null);
  const [options_veiculo, set_options_veiculo] = useState([])
  const loadVeiculos = () => {
    set_veiculo(null);
    transportador_api.getVeiculosAtivos(transportadorId).then(result => {
      if (result.status !== 200) {
        showMessage("Não foi possível carregar os veículos", result.message, 'error', null);
      }
      else {
        set_options_veiculo(result.data);
      }
    })
  }
  const handleVeiculo = (value) => {
    set_veiculo(value);
    setValue("veiculo", value, true);
    clearErrors("veiculo");
  }

  // DESTINO
  const [destino, set_destino] = useState(null);
  const [options_destino, set_options_destino] = useState([])
  const loadDestino = () => {
    set_destino(null);
    destino_api.getListAtivos().then(result => {
      if (result.status !== 200) {
        showMessage("Não foi possível carregar os destinos", result.message, 'error', null);
      }
      else {
        set_options_destino(result.data);
      }
    })
  }
  const handleDestino = (value) => {
    set_destino(value);
    setValue("destino", value, true);
    clearErrors("destino");

    let _destino = options_destino.filter(f => f.destinoId == value);
    if (_destino.length > 0) {
      setValue("cep", _destino[0].cep);
      set_cep(_destino[0].cep);
      setValue("logradouro", _destino[0].logradouro);
      setValue("numero", _destino[0].numero);
      setValue("complemento", _destino[0].complemento);
      setValue("bairro", _destino[0].bairro);
      setValue("cidade", _destino[0].cidade);
      setValue("uf", _destino[0].uf);
    }
  }

  const [cep, set_cep] = useState("");
  const handleCEPChange = (event) => {
    set_cep(event.target.value);
  }
  const handleCEPBlur = (event) => {
    if (event.target.value.length != 9)
      return;

    setLoading(true);
    cep_api.getEnderecoByCep(event.target.value).then(result => {
      setLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", "Cep não localizado", 'error', null);
        setValue("logradouro", "");
        setValue("bairro", "");
        setValue("cidade", "");
        setValue("uf", "");
      }
      else {
        setValue("logradouro", result.data.logradouro);
        setValue("bairro", result.data.bairro);
        setValue("cidade", result.data.localidade);
        setValue("uf", result.data.uf);
      }
    });
  }

  const handleTipoResiduoRetiradaChange = (tipoResiduoId) => {
    let _newlist = [];
    list_table.map(m => {
      if (m.tipoResiduoId == tipoResiduoId)
        m.quantidade = m.quantidadeEstoque;

      _newlist.push(m);
    })
    set_list_table(_newlist);
  }

  const handleQuantidadeChange = (tipoResiduoId, event) => {
    let _newlist = [];
    list_table.map(m => {
      if (m.tipoResiduoId == tipoResiduoId) {
        m.quantidade = event.target.value;

        if (event.target.value != "" && event.target.value > m.quantidadeEstoque) {
          m.quantidade = m.quantidadeEstoque;
          showMessage("Aviso", "A quantidade máxima permitida é o valor constante no estoque", 'error', null);
        }
      }
      _newlist.push(m);
    })
    set_list_table(_newlist);
  }

  const onSubmit = (data) => {
    if (list_table.filter(f => f.quantidade != null && f.quantidade != "" && f.quantidade > 0).length == 0) {
      showMessage("Aviso", "Informe as quantidades de saída", 'error', null);
      return;
    }

    let documento = data.documento.replaceAll("/", "").replaceAll(".", "").replaceAll("-", "");

    if (documento.length == 11) {
      if (!isValidCPF(documento)) {
        showMessage("Aviso", "CPF/CNPJ inválido", 'error', null);
        return;
      }
    }
    else if (documento.length == 14) {
      if (!isValidCNPJ(documento)) {
        showMessage("Aviso", "CPF/CNPJ inválido", 'error', null);
        return;
      }
    }
    else {
      showMessage("Aviso", "CPF/CNPJ inválido", 'error', null);
      return;
    }

    let json_submit = {
      guiaDestinacaoId: item == null ? 0 : item.guiaDestinacaoId,
      transportadorId: transportadorId,
      localId: session.localId,
      numeroEquipamento: data.numeroEquipamento,
      identificacao: data.identificacao,
      documento: documento.replace(/[^\d]+/g, ''),
      cep: data.cep.replace("-", ""),
      logradouro: data.logradouro,
      numero: data.numero,
      complemento: data.complemento,
      bairro: data.bairro,
      cidade: data.cidade,
      uf: data.uf,
      dataHora: formateDateApi(new Date()),
      guiaDestinacaoTipoResiduo: list_table.filter(f => f.quantidade != null && f.quantidade != "" && f.quantidade > 0),
      placa: veiculo,
      destinoId: destino,
    }

    setLoading(true);
    if (json_submit.guiaDestinacaoId == 0)
      guiadestinacao_api.post(json_submit).then(result => handleReturnSubmit(result));
    else
      showMessage("Aviso", "Não é permitido editar uma guia de destinação!", 'error', null);
  }

  const handleReturnSubmit = (result) => {
    setLoading(false);
    if (result.status !== 200) {
      showMessage("Aviso", result.message, 'error', null);
    }
    else {
      showMessage("Aviso", "Operação executada com sucesso", "success", function () { handleReturn() });
    }
  }

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Button color="Primary" onClick={Voltar}><i className="fas fa-chevron-left"></i>  Voltar</Button>
            <Card>
              <CardHeader>
                <h4 className="titleCard">Guia de Destinação</h4>
              </CardHeader>
              <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <Row>
                    <Col md="12"><h6 className="subtitleCard">Identificação da Guia de Destinação</h6></Col>
                    <Col lg="4" md="4" sm="12">
                      <FormGroup>
                        <label className="form-control-label">Número do Equipamento:</label>
                        <Input className="form-control"
                          autocomplete="off"
                          type="text"
                          name="numeroEquipamento"
                          maxLength="15"
                          innerRef={register({ required: false })}
                          disabled={form_disabled}
                        />
                      </FormGroup>
                    </Col>

                    <Col md="12"><h6 className="subtitleCard">Identificação do Transportador</h6></Col>
                    <Col lg="4" md="4" sm="12">
                      <FormGroup>
                        <label className="form-control-label">CPF/CNPJ:</label>
                        <Input className="form-control"
                          autocomplete="off"
                          type="text"
                          name="documento"
                          maxLength="14"
                          onBlur={(e) => handleCNPJBlur(e)}
                          innerRef={register({ required: true })}
                          disabled={form_disabled}
                        />
                        {errors.documento && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                      </FormGroup>
                    </Col>
                    <Col lg="8" md="8" sm="12">
                      <FormGroup>
                        <label className="form-control-label">Nome/Razão Social:</label>
                        <Input className="form-control"
                          autocomplete="off"
                          type="text"
                          name="identificacao"
                          maxLength="14"
                          innerRef={register({ required: true })}
                          readOnly={transportadorId != null}
                          disabled={form_disabled}
                        />
                        {errors.identificacao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                      </FormGroup>
                    </Col>
                  </Row>

                  {transportadorId != null &&
                    <Row>
                      <Col md="12"><h6 className="subtitleCard">Transporte e Destinação</h6></Col>
                      <Col lg="4" md="4" sm="12">
                        <FormGroup>
                          <label className="form-control-label">Veículo:</label>
                          <Select
                            name="veiculo"
                            options={options_veiculo}
                            getOptionLabel={p => p.placa}
                            getOptionValue={p => p.placa}
                            value={veiculo != null && options_veiculo.find(obj => obj.placa === veiculo)}
                            onChange={(e) => { handleVeiculo(e.placa) }}
                            classNamePrefix="select"
                            placeholder="[ Selecione ]"
                            ref={e => register(
                              { name: "veiculo" },
                              { required: true })
                            }
                            isDisabled={form_disabled}
                          />
                          {errors.veiculo && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                      </Col>
                      <Col lg="8" md="8" sm="12">
                        <FormGroup>
                          <label className="form-control-label">Destino:</label>
                          <Select
                            name="destino"
                            options={options_destino}
                            getOptionLabel={p => p.identificacao}
                            getOptionValue={p => p.destinoId}
                            value={destino != null && options_destino.find(obj => obj.destinoId === destino)}
                            onChange={(e) => { handleDestino(e.destinoId) }}
                            classNamePrefix="select"
                            placeholder="[ Selecione ]"
                            ref={e => register(
                              { name: "destino" },
                              { required: true })
                            }
                            isDisabled={form_disabled}
                          />
                          {errors.destino && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                      </Col>
                    </Row>
                  }

                  <Row>
                    <Col md="12"><h6 className="subtitleCard">Endereço do Destino</h6></Col>
                    <Col lg="2" md="3" sm="12">
                      <FormGroup>
                        <label className="form-control-label">CEP</label>
                        <InputCEP
                          type="text"
                          name="cep"
                          onChange={handleCEPChange}
                          onBlur={handleCEPBlur}
                          value={cep}
                          autocomplete="off"
                          inputRef={register({ required: true })}
                          readOnly={transportadorId != null}
                          disabled={form_disabled}
                        />
                        {errors.cep && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                      </FormGroup>
                    </Col>
                    <Col lg="6" md="6" sm="12">
                      <FormGroup>
                        <label className="form-control-label">Logradouro</label>
                        <Input className="form-control"
                          autocomplete="off"
                          type="text"
                          name="logradouro"
                          maxLength="150"
                          readOnly={true}
                          innerRef={register({ required: true })}
                          disabled={form_disabled}
                        />
                        {errors.logradouro && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                      </FormGroup>
                    </Col>
                    <Col lg="2" md="2" sm="6">
                      <FormGroup>
                        <label className="form-control-label">Número</label>
                        <Input className="form-control"
                          maxLength="10"
                          autocomplete="off"
                          type="text"
                          name="numero"
                          innerRef={register({ required: true })}
                          readOnly={transportadorId != null}
                          disabled={form_disabled}
                        />
                        {errors.numero && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                      </FormGroup>
                    </Col>
                    <Col lg="2" md="2" sm="6">
                      <FormGroup>
                        <label className="form-control-label">Complemento</label>
                        <Input className="form-control"
                          maxLength="50"
                          autocomplete="off"
                          type="text"
                          name="complemento"
                          innerRef={register({ required: false })}
                          readOnly={transportadorId != null}
                          disabled={form_disabled}
                        />
                      </FormGroup>
                    </Col>
                    <Col lg="5" md="5" sm="12">
                      <FormGroup>
                        <label className="form-control-label">Bairro</label>
                        <Input className="form-control"
                          maxLength="150"
                          autocomplete="off"
                          type="text"
                          name="bairro"
                          readOnly={true}
                          innerRef={register({ required: true })}
                          disabled={form_disabled}
                        />
                        {errors.bairro && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                      </FormGroup>
                    </Col>
                    <Col lg="5" md="5" sm="10">
                      <FormGroup>
                        <label className="form-control-label">Cidade</label>
                        <Input className="form-control"
                          maxLength="150"
                          autocomplete="off"
                          type="text"
                          name="cidade"
                          readOnly={true}
                          innerRef={register({ required: true })}
                          disabled={form_disabled}
                        />
                        {errors.cidade && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                      </FormGroup>
                    </Col>
                    <Col lg="2" md="2" sm="2">
                      <FormGroup>
                        <label className="form-control-label">UF</label>
                        <Input className="form-control"
                          maxLength="2"
                          autocomplete="off"
                          type="text"
                          name="uf"
                          readOnly={true}
                          innerRef={register({ required: true })}
                          disabled={form_disabled}
                        />
                        {errors.uf && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12"><h6 className="subtitleCard">Lista de Resíduos</h6></Col>
                    <Col lg="6" md="6" sm="6">
                      <label className="form-control-label">Resíduo</label>
                    </Col>
                    {!form_disabled &&
                      <Col lg="3" md="3" sm="3">
                        <label className="form-control-label">Estoque</label>
                      </Col>
                    }
                    {!form_disabled &&
                      <Col lg="1" md="1" sm="1">
                        <label className="form-control-label">Ação</label>
                      </Col>
                    }
                    <Col lg="2" md="2" sm="2">
                      <label className="form-control-label">Saída</label>
                    </Col>
                  </Row>
                  {list_table.map((m, key) => (
                    <Row key={key}>
                      <Col lg="6" md="6" sm="6">
                        <FormGroup>
                          <Input type="text" readOnly="true" value={m.tipoResiduoDescricao}></Input>
                        </FormGroup>
                      </Col>
                      {!form_disabled &&
                        <Col lg="3" md="3" sm="3">
                          <FormGroup>
                            <Input type="text" readOnly="true" value={m.quantidadeEstoque + " " + m.tipoResiduoUnidade}></Input>
                          </FormGroup>
                        </Col>
                      }
                      {!form_disabled &&
                        <Col lg="1" md="1" sm="1">
                          <Button size="sm" type="button" onClick={() => handleTipoResiduoRetiradaChange(m.tipoResiduoId)}><i className="fas fa-chevron-right"></i></Button>
                        </Col>
                      }
                      <Col lg="2" md="2" sm="2">
                        <FormGroup>
                          <Input type="number" readOnly={m.quantidade == null} disabled={form_disabled} onChange={(e) => handleQuantidadeChange(m.tipoResiduoId, e)} value={m.quantidade}></Input>
                        </FormGroup>
                      </Col>
                    </Row>
                  ))}
                  {!form_disabled &&
                    <Row>
                      <Col lg="12" md="12" sm="12" className="text-center">
                        <Button color="success" className="btn-mobile" type="submit"><i className="fas fa-save"></i>  Salvar</Button>
                      </Col>
                    </Row>
                  }
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>

      </div>

    </>
  );
}

